export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="font-heading text-xl font-black tracking-tight mb-4 block" style={{ fontFamily: 'var(--font-heading)' }}>
              <span className="text-primary-400">51</span>
              <span className="text-background-50">cg</span>
              <span className="text-primary-400">吃瓜</span>
            </span>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              51cg吃瓜网是全网领先的娱乐资讯聚合平台，聚焦51今日吃瓜、每日吃瓜最新爆料、热门事件及独家消息。
              实时更新51cg吃瓜今日动态，做吃瓜群众最信赖的第一手瓜源。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-8 h-8 rounded-lg bg-foreground-800 flex items-center justify-center text-background-300 hover:text-primary-400 hover:bg-foreground-700 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 rounded-lg bg-foreground-800 flex items-center justify-center text-background-300 hover:text-primary-400 hover:bg-foreground-700 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 rounded-lg bg-foreground-800 flex items-center justify-center text-background-300 hover:text-primary-400 hover:bg-foreground-700 transition-colors cursor-pointer">
                <i className="ri-vidicon-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">快速导航</h4>
            <div className="space-y-2.5">
              <a href="#updates" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">最新动态</a>
              <a href="#carousel" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">焦点专题</a>
              <a href="#cards" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">热门吃瓜</a>
              <a href="#ranking" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">热度榜单</a>
              <a href="#faq" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">内容分类</h4>
            <div className="space-y-2.5">
              <a href="#index" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">明星八卦</a>
              <a href="#index" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">影视综艺</a>
              <a href="#index" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">网红动态</a>
              <a href="#index" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">独家揭秘</a>
              <a href="#index" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">话题广场</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">合作伙伴</h4>
            <p className="text-sm text-foreground-400 whitespace-nowrap">
              暂无合作伙伴信息
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400 whitespace-nowrap">
              &copy; 2026 51cg吃瓜网 - 51吃瓜官网全网最新。保留所有权利。
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">用户协议</a>
              <a href="#hero" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#contact" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}